import { create } from 'zustand';

export type ManualTrackExecutor = (params: {
  credentialId?: string;
}) => Promise<boolean>;

export type ManualTrackOptions = {
  closeDialogOnStart?: boolean;
};

type ManualTrackCredentialsStoreState = {
  isConfigureCredentialsOpen: boolean;
  pendingExecute?: ManualTrackExecutor;
  pendingOptions?: ManualTrackOptions;
  setIsConfigureCredentialsOpen: (open: boolean) => void;
  setPendingExecute: (
    execute: ManualTrackExecutor,
    options?: ManualTrackOptions,
  ) => void;
  clearPendingExecute: () => void;
};

export const useManualTrackCredentialsStore =
  create<ManualTrackCredentialsStoreState>((set) => ({
    isConfigureCredentialsOpen: false,
    pendingExecute: undefined,
    pendingOptions: undefined,
    setIsConfigureCredentialsOpen: (open) => {
      set({ isConfigureCredentialsOpen: open });
    },
    setPendingExecute: (execute, options) => {
      set({ pendingExecute: execute, pendingOptions: options });
    },
    clearPendingExecute: () => {
      set({ pendingExecute: undefined, pendingOptions: undefined });
    },
  }));
